(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["global-navigation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-cda-back]');
    if (!button) return;

    const referrer = document.referrer;
    const sameSiteReferrer = referrer && new URL(referrer).origin === window.location.origin;

    if (sameSiteReferrer && window.history.length > 1) {
      window.history.back();
      return;
    }

    window.location.assign(button.dataset.homeUrl);
  });
  } catch(e) { console.error(e); }
})();

})();
